var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.583 17.917 4.624-1.779c.296-.114.444-.17.582-.245.123-.066.24-.142.35-.228.125-.096.237-.208.46-.432l9.4-9.4A2.357 2.357 0 1 0 14.667 2.5l-9.4 9.4c-.224.224-.336.336-.432.46a2.5 2.5 0 0 0-.227.35c-.075.138-.132.286-.245.582l-1.779 4.625zm0 0 1.715-4.46c.123-.319.184-.478.29-.551a.417.417 0 0 1 .315-.067c.126.024.247.145.489.386l1.882 1.883c.242.242.363.362.387.488a.417.417 0 0 1-.067.316c-.073.105-.233.167-.552.29l-4.459 1.715z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil01);
export default __webpack_public_path__ + "static/media/pencil01.f10509c94076b1cf44a8be9c333b8637.svg";
export { ForwardRef as ReactComponent };